import React, { Component } from 'react';
// import axios from 'axios';
// import StackTrace from "stacktrace-js";

const style = {
    container: {
        textAlign: "center", 
        backgroundColor: "rgba(0,0,0,.5)", 
        color: "#fff", 
        padding: "1vw 0"
    },
    title: {
        margin: "0"
    },
    msg : {
        margin: "0"
    }
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // const self = this;
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })

        // if (process.env.NODE_ENV === "production") {
        //     StackTrace.fromError(error).then(err => {
        //         let errString = "";
        //         let errLength = err.length > 10 ? 10 : err.length;
        //         for (let index = 0; index < errLength; index++) {
        //             errString += `in ${err[index].fileName}:${err[index].lineNumber} \n`;
        //         }

        //         self.reportToDiscord(errString);
        //     })
        // }    

        // You can also log error messages to an error reporting service here
    }

    render() {
        if (this.state.errorInfo) {
            return (
                <div style={style.container}>
                    <h2 style={style.title}>
                        SORRY FOR THE INCONVENIENCE
                    </h2>
                    <h4 style={style.msg}>
                        This error has been reported. Please try to open it in another browser.
                    </h4>
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;
